import { Component } from 'react';

export default class CheckboxItem extends Component {
  
    handleCheckboxChange = (event) => {
        const { checkboxChangeCallback } = this.props;
        checkboxChangeCallback(event.target.checked, event.target.name);
    };

    formatName = (name) => {
        if(!name) return name;
        name = name.charAt(0).toUpperCase() + name.slice(1);
        return name.replace(/_/g, ' ');
    }

    render() {
        const { checkboxname, parentkey, checkboxValue, checked, parentClass } = this.props;
        return (
            <li>
                <div className='check-box'>
                    {/* <div className='checkbox'>
                        <input type='checkbox'
                            checked={ checked }
                            name={ checkboxname }
                            id={ `${ parentkey }${ checkboxname }${ parentClass }` }
                            onChange={ this.handleCheckboxChange }
                            value={ checkboxValue }
                        />
                        <label htmlFor={ `${ parentkey }${ checkboxname }${ parentClass }` }>
                            <span>{this.formatName(checkboxname)}</span>
                        </label>
                    </div> */}

                    <div className={ `cus-checkbox ${ checked ? 'active' : '' }` } >
                        <input type="checkbox" 
                            checked={ checked }
                            name={ checkboxname }
                            id={ `${ parentkey }${ checkboxname }${ parentClass }` }
                            onChange={ this.handleCheckboxChange }
                            value={ checkboxValue }
                        />
                        <label htmlFor={ `${ parentkey }${ checkboxname }${ parentClass }` }>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="none" stroke-width="2px" stroke="white" stroke-linecap="round" viewBox="0 0 21 21">
                                    <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                                </svg>
                            </span>
                            {this.formatName(checkboxname)}
                        </label>
                    </div>
                </div>
            </li>

        )
    }
}